import React from 'react'
import { graphql, usePaginationFragment } from 'react-relay'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { GuildCard } from '@newComponents/Guild/GuildCard'

import { PresentationGuilds_presentation$key } from './__generated__/PresentationGuilds_presentation.graphql'

type PresentationGuildProps = {
  presentation: PresentationGuilds_presentation$key
}

const PresentationGuilds = (props: PresentationGuildProps) => {
  const { data } = usePaginationFragment(
    graphql`
      fragment PresentationGuilds_presentation on Presentation
      @refetchable(queryName: "PresentationGuildsPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 2 }
        cursor: { type: "Cursor" }
      ) {
        guilds(first: $count, after: $cursor)
          @connection(key: "PresentationGuilds_presentation_guilds") {
          edges {
            node {
              id
              ...GuildCardNew_guild
            }

            cursor
          }
        }
      }
    `,
    props.presentation
  )

  if (data.guilds.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$5'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$color'>Presented with these Guilds</Strong>
        <Separator borderColor='$borderColor' />
      </XStack>

      <XStack flexWrap='wrap' gap='$4'>
        {data.guilds.edges.map((edge) => (
          <YStack key={edge.cursor} flexGrow={1} flexBasis={240} $sm={{ flexBasis: '100%' }} maxWidth='100%'>
            <GuildCard
              guild={edge.node}
              expand
              limitDescriptionLines={3}
            />
          </YStack>
        ))}
      </XStack>
    </YStack>
  )
}

export default PresentationGuilds
